import { render } from "./LwNotice.vue?vue&type=template&id=c3ea1764&scoped=true"
import script from "./LwNotice.vue?vue&type=script&lang=js"
export * from "./LwNotice.vue?vue&type=script&lang=js"

import "./LwNotice.vue?vue&type=style&index=0&id=c3ea1764&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ea1764"]])

export default __exports__